export default __webpack_public_path__ + "static/media/discordDesk.433330ad.svg";